import { render, staticRenderFns } from "./CertificationManagement.vue?vue&type=template&id=213603dd&scoped=true"
import script from "./CertificationManagement.vue?vue&type=script&lang=js"
export * from "./CertificationManagement.vue?vue&type=script&lang=js"
import style0 from "./CertificationManagement.vue?vue&type=style&index=0&id=213603dd&prod&lang=scss"
import style1 from "./CertificationManagement.vue?vue&type=style&index=1&id=213603dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213603dd",
  null
  
)

export default component.exports